import {
  Box,
  Button,
  CircularProgress,
} from "@mui/material";
import {HugeiconsIcon} from "@hugeicons/react";
import {ArrowRight01Icon, FileUploadIcon} from "@hugeicons/core-free-icons";
import React from "react";
import {ProjectForm} from "./ProjectForm";
import {FileUploader} from "react-drag-drop-files";
import {toast} from "react-toastify";
import {deepPurple} from "@mui/material/colors";
import Typography from "@mui/material/Typography";

export const ProjectCreateForm = ({project, setProject, languages, organizations, fetchData, loading}) => {
  return (
    <>
      <ProjectForm
        setProject={setProject}
        project={project}
        languages={languages}
        organizations={organizations}
        fetchData={fetchData}
      />

      <Box sx={{p: 3}}>
        <Typography fontWeight={600} fontSize={"0.95rem"} sx={{mb: 0.5}}>
          Start from an existing assistant <Typography component="span" color="text.secondary" fontWeight={400}>(optional)</Typography>
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{mb: 1.5}}>
          Upload a JSON export to continue working from an existing assistant. Leave this empty to create a new assistant from scratch.
        </Typography>
        <FileUploader
          multiple={false}
          handleChange={(file) => {
            setProject(prev => ({...prev, file}));
            toast.info("Make sure you have attached the correct file before saving.");
          }}
          name="file"
          types={["json"]}
        >
          <Box
            sx={{
              border: 2,
              borderStyle: "dashed",
              p: 4,
              borderColor: deepPurple[300],
              bgcolor: deepPurple[50],
              borderRadius: 4,
              textAlign: "center",
              cursor: "pointer",
            }}
          >
            <HugeiconsIcon icon={FileUploadIcon} size={40} color={deepPurple[300]}/>
            <Typography fontWeight={"bold"} fontSize={18} color={deepPurple[500]}>
              {project?.file ? "You have attached this file" : "Optional: drag and drop JSON file here"}
            </Typography>
            <Typography color={deepPurple[500]} fontSize={15}>
              {project?.file ? project.file.name : "or click to upload (50 MB max)"}
            </Typography>
          </Box>
        </FileUploader>

        {project?.file && (
          <Button
            type="button"
            variant="ghost"
            onClick={() => setProject(prev => ({...prev, file: null}))}
            sx={{mt: 1, borderRadius: "8px !important"}}
          >
            Remove file
          </Button>
        )}
      </Box>

      <Box sx={{px: 3, pb: 2, display: "flex", justifyContent: "flex-end", alignItems: "center", gap: 2}}>
        <Button
          data-tour="create-project-submit"
          type="submit"
          variant="modal"
          disabled={!project?.name || !project?.language || loading}
          sx={{borderRadius: "8px !important"}}
          endIcon={loading ? <CircularProgress size={18} color="secondary"/> : <HugeiconsIcon icon={ArrowRight01Icon} size={18}/>}>
          Submit
        </Button>
      </Box>
    </>
  );
};
